"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var argsAtIndexes = function argsAtIndexes() {
  for (var _len = arguments.length, indexes = new Array(_len), _key = 0; _key < _len; _key++) {
    indexes[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return indexes.map(function (idx) {
      return args[idx];
    }).join('_');
  };
};

var _default = function _default(originalValue) {
  if (typeof originalValue === 'function') {
    return originalValue;
  }

  if (typeof originalValue === 'string') {
    return function () {
      return originalValue;
    };
  }

  if (typeof originalValue === 'number') {
    return argsAtIndexes(originalValue);
  }

  if (Array.isArray(originalValue)) {
    return argsAtIndexes.apply(void 0, (0, _toConsumableArray2["default"])(originalValue));
  }

  return null;
};

exports["default"] = _default;